import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../api.js';
import Spinner from '../components/Spinner.jsx';

export default function DiveLog() {
  const { id } = useParams();
  const [dives, setDives]     = useState([]);
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ datum: new Date().toISOString().slice(0,10), dauer_min: '', max_tiefe: '', bedingungen: '', ort: '' });
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState(null);

  const load = () => {
    setLoading(true);
    Promise.all([api.getDives(id), api.getProgress(id)])
      .then(([d, p]) => { setDives(d); setStudent(p.student); })
      .catch(console.error)
      .finally(() => setLoading(false));
  };
  useEffect(load, [id]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      await api.addDive(id, { ...form, dauer_min: Number(form.dauer_min), max_tiefe: Number(form.max_tiefe) });
      setShowForm(false);
      setForm({ datum: new Date().toISOString().slice(0,10), dauer_min: '', max_tiefe: '', bedingungen: '', ort: '' });
      load();
    } catch (err) {
      setError(err.message);
    } finally { setSaving(false); }
  };

  const f = (k, v) => setForm((prev) => ({ ...prev, [k]: v }));

  if (loading) return <div className="flex justify-center py-12"><Spinner size="lg" /></div>;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <Link to="/ausbilder" className="hover:text-blue-600">Schüler</Link>
        <span>/</span>
        <Link to={`/ausbilder/schueler/${id}`} className="hover:text-blue-600">{student?.kuerzel}</Link>
        <span>/</span>
        <span className="font-medium text-gray-900">Tauchgänge</span>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-500">{dives.length} Tauchgänge geloggt</p>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary text-xs">
          {showForm ? '✕ Abbrechen' : '+ Tauchgang eintragen'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={submit} className="card space-y-3 border-blue-200 bg-blue-50">
          <h3 className="font-semibold text-sm text-blue-900">Neuer Tauchgang</h3>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Datum</label>
              <input type="date" className="input" value={form.datum} onChange={(e) => f('datum', e.target.value)} required />
            </div>
            <div>
              <label className="label">Dauer (min)</label>
              <input type="number" min="1" className="input" placeholder="25" value={form.dauer_min} onChange={(e) => f('dauer_min', e.target.value)} required />
            </div>
            <div>
              <label className="label">Max. Tiefe (m)</label>
              <input type="number" step="0.5" min="0.5" className="input" placeholder="8.5" value={form.max_tiefe} onChange={(e) => f('max_tiefe', e.target.value)} required />
            </div>
            <div>
              <label className="label">Ort</label>
              <input className="input" placeholder="Maschsee" value={form.ort} onChange={(e) => f('ort', e.target.value)} />
            </div>
          </div>
          <div>
            <label className="label">Bedingungen</label>
            <input className="input" placeholder="Nullsicht, 8°C, leichte Strömung" value={form.bedingungen} onChange={(e) => f('bedingungen', e.target.value)} />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" className="btn-primary w-full" disabled={saving}>
            {saving ? 'Speichern…' : 'Tauchgang eintragen'}
          </button>
        </form>
      )}

      {/* Tauchgangliste */}
      <div className="space-y-2">
        {dives.length === 0 && (
          <div className="card text-center text-gray-400 py-8 text-sm">Noch keine Tauchgänge eingetragen.</div>
        )}
        {dives.map((d, i) => (
          <div key={d.id} className="card">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-sm text-gray-900">TG #{dives.length - i}</span>
                  <span className="text-xs text-gray-400">{d.datum}</span>
                </div>
                <div className="flex gap-4 text-sm text-gray-700 mt-1">
                  <span>⏱ {d.dauer_min} min</span>
                  <span>📏 {d.max_tiefe} m</span>
                  {d.ort && <span>📍 {d.ort}</span>}
                </div>
                {d.bedingungen && <p className="text-xs text-gray-400 mt-0.5">{d.bedingungen}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
